import * as React from 'react'

const CheckboxUncheckedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="1.5" y="1.5" width="21" height="21" rx="6.5" stroke="currentColor" strokeWidth="3" />
    </svg>
  )
}

export default CheckboxUncheckedIcon
